import type {
  LinksLinkBlockComponent,
  SectionsTwistoAccountComponent,
} from '@twisto/api-cms'

import { Button, StoreButton } from 'homepage/components/atoms'

import { QRWidget } from '../../molecules'

import * as styles from './twisto-account.styles'

const LinkBlock = (
  link: Pick<LinksLinkBlockComponent, 'headline' | 'text' | 'url' | 'label'>
) => (
  <a css={styles.link} href={link.url}>
    <span css={styles.linkHeadline}>
      {link.headline}
      <span css={styles.badge}>{link.label}</span>
    </span>
    {link.text}
  </a>
)

export function TwistoAccount({
  title,
  description,
  cta,
  qr,
  leftCol,
  rightCol,
  leftColTitle,
  rightColTitle,
  stores,
}: SectionsTwistoAccountComponent) {
  return (
    <div css={styles.wrap}>
      <div css={styles.heading}>
        <div css={styles.title}>{title}</div>
        {description && <div css={styles.desc}>{description}</div>}

        {cta?.text && cta.url && (
          <Button styles={styles.cta} text={cta.text} url={cta.url} />
        )}

        {qr && <QRWidget {...qr} styles={styles.qr} />}

        {stores && (
          <div css={styles.stores} style={{ background: qr?.background }}>
            {stores.map((store) => (
              <StoreButton key={store.id} {...store} />
            ))}
          </div>
        )}
      </div>

      <div css={styles.lists}>
        {leftColTitle && <div css={styles.colTitle}>{leftColTitle}</div>}
        {leftCol?.map((item) => <LinkBlock key={item.id} {...item} />)}
      </div>

      <div css={styles.lists}>
        {rightColTitle && <div css={styles.colTitle}>{rightColTitle}</div>}
        {rightCol?.map((item) => <LinkBlock key={item.id} {...item} />)}
      </div>
    </div>
  )
}
